import apiHelper from '@/services/helper'

const getManageUserList = async ({ limit = 10, offset = 1, keyword = null }) => {
    try {
        let url = '/admin/staff/get-all'
        return (await apiHelper.getWithFirebaseToken(url, { limit, offset, keyword })).data
    } catch (error) {
        console.log('error', error)
        return Promise.reject(error)
    }
}

const getEmployeeRole = async () => {
    try {
        let url = '/admin/staff/roles'
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (err) {
        throw new Error(err)
    }
}

const createEmployee = async (param) => {
    try {
        let url = '/admin/staff/create'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (err) {
        throw err.response
    }
}

const editEmployee = async (param) => {
    try {
        let url = `/admin/staff/${param.userId}`
        return (await apiHelper.putWithFirebaseToken(url, param)).data
    } catch (err) {
        throw err.response
    }
}

export default {
    getManageUserList,
    getEmployeeRole,
    createEmployee,
    editEmployee
}
